import type { LayerPattern } from '@pn/core/domain/layer';
import { DotsPatternModule } from './DotsPatternModule';
import {
  CrossHatchPatternModule,
  HatchDiag135PatternModule,
  HatchDiag45PatternModule,
} from './HatchPatternModules';

type FrameState = {
  map: mapboxgl.Map;
  gl: WebGLRenderingContext | WebGL2RenderingContext;
  matrix: number[];
  dpr: number;
};

export type UniformLocations = Record<string, WebGLUniformLocation | null>;

export type PatternModule<Props> = {
  /** shader sources */
  vert: string;
  frag: string;

  /** called once after program is created; gets uniform/attrib locations */
  init(
    gl: WebGLRenderingContext | WebGL2RenderingContext,
    program: WebGLProgram
  ): UniformLocations;

  /** called every frame before draw; set uniforms, bind textures, etc */
  setUniforms(frame: FrameState, uLocs: UniformLocations, props: Props): void;

  /** optional cleanup for textures, buffers created by the pattern */
  destroy?(gl: WebGLRenderingContext | WebGL2RenderingContext): void;
};

export const patternModules: Record<LayerPattern, PatternModule<any>> = {
  crosshatch: CrossHatchPatternModule,
  hatch_diag45: HatchDiag45PatternModule,
  hatch_diag135: HatchDiag135PatternModule,
  dots: DotsPatternModule,
};
